import { render, staticRenderFns } from "./2025newYear.vue?vue&type=template&id=67580361&scoped=true&"
import script from "./2025newYear.vue?vue&type=script&lang=js&"
export * from "./2025newYear.vue?vue&type=script&lang=js&"
import style0 from "./2025newYear.vue?vue&type=style&index=0&id=67580361&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67580361",
  null
  
)

export default component.exports